// import constant
import { SET_BOT_STATUS } from "../constant";

const initialValue = {
  isAuth: false,
};
const botStatus = (state = initialValue, action) => {
  switch (action.type) {
    case SET_BOT_STATUS:
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
};

export default botStatus;
